/** @file PadletSpeechBubbleShape schema */
import {
  defaultColorNames,
  DefaultColorStyle,
  DefaultDashStyle,
  DefaultFillStyle,
  DefaultFontStyle,
  DefaultHorizontalAlignStyle,
  DefaultSizeStyle,
  DefaultVerticalAlignStyle,
  StyleProp,
  T,
  TLBaseShape,
  TLDefaultColorStyle,
  TLDefaultDashStyle,
  TLDefaultFillStyle,
  TLDefaultFontStyle,
  TLDefaultHorizontalAlignStyle,
  TLDefaultSizeStyle,
  TLDefaultVerticalAlignStyle,
  VecModel,
  vecModelValidator,
} from 'tldraw'

// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/styles/TLColorStyle.ts#L444
const DefaultLabelColorStyle = StyleProp.defineEnum('tldraw:padletSpeechBubbleLabelColor', {
  defaultValue: 'black',
  values: defaultColorNames,
})

// Similar to geoShapeProps
// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/shapes/TLGeoShape.ts#L77C14-L77C27
const padletSpeechBubbleShapeProps = {
  w: T.nonZeroNumber,
  h: T.nonZeroNumber,
  color: DefaultColorStyle,
  labelColor: DefaultLabelColorStyle,
  size: DefaultSizeStyle,
  font: DefaultFontStyle,
  align: DefaultHorizontalAlignStyle,
  verticalAlign: DefaultVerticalAlignStyle,
  growY: T.positiveNumber,
  text: T.string,
  tail: vecModelValidator,
  fill: DefaultFillStyle,
  url: T.linkUrl,
  scale: T.nonZeroNumber,
  dash: DefaultDashStyle,
}

// Similar to TLGeoShapeProps
// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/shapes/TLGeoShape.ts
interface PadletSpeechBubbleShapeProps {
  w: number
  h: number
  color: TLDefaultColorStyle
  labelColor: TLDefaultColorStyle
  size: TLDefaultSizeStyle
  font: TLDefaultFontStyle
  align: TLDefaultHorizontalAlignStyle
  verticalAlign: TLDefaultVerticalAlignStyle
  growY: number
  text: string
  tail: VecModel
  fill: TLDefaultFillStyle
  url: string
  scale: number
  dash: TLDefaultDashStyle
}

type PadletSpeechBubbleShape = TLBaseShape<'padlet-speech-bubble', PadletSpeechBubbleShapeProps>

export { PadletSpeechBubbleShape, PadletSpeechBubbleShapeProps, padletSpeechBubbleShapeProps }
